/**
 * @generated SignedSource<<d9aa52d596f79ee1d9c1921d0a21e798>>
 * @relayHash 0b2a3eaaa6f9df353def4a88ff63a46e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7c0ecb0b97752b2869bcf56bc9bea4a25d220c498fed91a36a9d9e3ede4e82ee

import type { ConcreteRequest } from 'relay-runtime';
export type GraphQLReactionContentType = "BLOGPOST" | "COMMENT" | "PAGE" | "%future added value";
export type InlineReactionsPubSubHandlerSummaryRefetchQuery$variables = {
  cloudId: string;
  contentId: string;
  contentType: GraphQLReactionContentType;
};
export type InlineReactionsPubSubHandlerSummaryRefetchQuery$data = {
  readonly confluence_contentReactionsSummary: {
    readonly reactionsSummary: ReadonlyArray<{
      readonly ari: string | null | undefined;
      readonly containerAri: string | null | undefined;
      readonly reactionsCount: number | null | undefined;
      readonly reactionsSummaryForEmoji: ReadonlyArray<{
        readonly count: number | null | undefined;
        readonly emojiId: string | null | undefined;
        readonly reacted: boolean | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type InlineReactionsPubSubHandlerSummaryRefetchQuery = {
  response: InlineReactionsPubSubHandlerSummaryRefetchQuery$data;
  variables: InlineReactionsPubSubHandlerSummaryRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentType"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
      },
      {
        "kind": "Variable",
        "name": "contentType",
        "variableName": "contentType"
      }
    ],
    "concreteType": "ConfluenceReactionSummary",
    "kind": "LinkedField",
    "name": "confluence_contentReactionsSummary",
    "plural": false,
    "selections": [
      {
        "concreteType": "ConfluenceReactionsSummaryResponse",
        "kind": "LinkedField",
        "name": "reactionsSummary",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "ari"
          },
          {
            "kind": "ScalarField",
            "name": "containerAri"
          },
          {
            "kind": "ScalarField",
            "name": "reactionsCount"
          },
          {
            "concreteType": "ConfluenceReactionsSummaryForEmoji",
            "kind": "LinkedField",
            "name": "reactionsSummaryForEmoji",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "emojiId"
              },
              {
                "kind": "ScalarField",
                "name": "count"
              },
              {
                "kind": "ScalarField",
                "name": "reacted"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "InlineReactionsPubSubHandlerSummaryRefetchQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InlineReactionsPubSubHandlerSummaryRefetchQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "0b2a3eaaa6f9df353def4a88ff63a46e",
    "id": "7c0ecb0b97752b2869bcf56bc9bea4a25d220c498fed91a36a9d9e3ede4e82ee",
    "metadata": {},
    "name": "InlineReactionsPubSubHandlerSummaryRefetchQuery",
    "operationKind": "query",
    "text": "query InlineReactionsPubSubHandlerSummaryRefetchQuery($cloudId:ID!,$contentId:ID!,$contentType:GraphQLReactionContentType!){confluence_contentReactionsSummary(cloudId:$cloudId,contentId:$contentId,contentType:$contentType){reactionsSummary{ari,containerAri,reactionsCount,reactionsSummaryForEmoji{emojiId,count,reacted}}}}"
  }
};
})();

(node as any).hash = "085d906d041b6881f9e1e396bc97ba34";

export default node;
